export enum CustomersFilterTasks {
  filterCustomers = "filterCustomers",
  searchCustomers = "searchCustomers",
  getAllCustomers = "getAllCustomers"
}

export interface CustomerFilterSkipLimit {
  limit: number;
  skip: number;
}

export interface CustomerFilterBaseQuery {
  marketingAllowed?: boolean;
  isRequiredPhoneNumber?: boolean;
  hasTransactions?: boolean;
}

export interface SearchCustomerQuery {
  query: string;
}

export interface FilterCustomerQuery {
  filterObj: object;
}

export type SearchCustomerQueryWithSkipLimit = SearchCustomerQuery &
  CustomerFilterSkipLimit;
export type FilterCustomerQueryWithSkipLimit = FilterCustomerQuery &
  CustomerFilterSkipLimit;
export type CustomerFilterBaseQueryWithSkipLimit = CustomerFilterBaseQuery &
  CustomerFilterSkipLimit;

export interface CustomerQueryTask {
  task: CustomersFilterTasks;
  query: CustomerFilterBaseQuery | SearchCustomerQuery | FilterCustomerQuery;
}

export interface ImportCustomersWizardProps {
  isOpen: boolean;
  onClose: () => void;
}

export interface StepIndicatorProps {
  step: number;
  label: string;
  active?: boolean;
}

export interface MapAttributesStepProps {
  columns: string[];
  rowSample: Record<string, string>;
  rows: Record<string, string>[];
  onBack: () => void;
  onNext: (
    mapping: Record<string, string>,
    uniqueField: string,
    customAttributes: { name: string; type: string }[]
  ) => void;
}

export interface ImportSummaryStepProps {
  selectedFile: File | null;
  mapping: Record<string, string>;
  uniqueField: string;
  onBack: () => void;
  onImport: () => void;
}
